import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children, adminOnly = false }) => {
    const { user, loading } = useAuth();
    if (loading || user === null) {
        return (
            <div data-testid="loading-state" className="min-h-[60vh] flex items-center justify-center">
                <div className="w-10 h-10 border-4 border-[hsl(var(--royal))] border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }
    if (user === false) return <Navigate to={adminOnly ? "/admin/login" : "/login"} replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
    return children;
};

export default ProtectedRoute;
